<template>
    <div>
        <TheHeader class="pc-header"  />
        <BaseTitle class="example-title" :infor="infor" />
        <TheExampleExampleList :exampleList="exampleList" />
        <TheFooter class="pc-the-footer-other" />
    </div>
</template>

<script>

    import TheHeader from '@/components/module/TheHeader'
    import TheFooter from '@/components/module/TheFooter'
    import '@/assets/less/module/module-the-header_pc-header.less'
    import '@/assets/less/module/module-the-footer-other_pc-the-footer-other.less'

    import BaseTitle from '@/components/module/BaseTitle'
    import TheExampleExampleList from '@/components/module/TheExampleExampleList'


    import '@/assets/less/module/module-the-header_pc-header.less'
    import '@/assets/less/module/module-the-footer-other_pc-the-footer-other.less'

    export default {
        name: 'PCExample',
        props: {
                infor: Object,
                exampleList: Array
        },
        components: {
            TheHeader,
            TheFooter,
            BaseTitle,
            TheExampleExampleList
        }
    }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


</style>